import api from "../../../api";

const BASE = "/api/mailbox";

/** The current user's mailbox connections (Gmail is always listed). */
export const getMailboxes = () => api.get(`${BASE}/`).then((r) => r.data);

/** Start Gmail consent: resolves to the Google URL to send the browser to. */
export const startGmailConnect = () =>
  api.post(`${BASE}/google/connect/`).then((r) => r.data.auth_url);

export const disconnectGmail = () =>
  api.post(`${BASE}/google/disconnect/`).then((r) => r.data);

/**
 * Send one email from the agent's connected Gmail. `formData` carries to / cc /
 * bcc, subject, body, attachments and client_key (one per email, so a retry or
 * a double click never sends a second copy).
 */
export const sendMailboxEmail = (formData) =>
  api.post(`${BASE}/send/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);

/** A page of conversations, live from Gmail. `folder`: inbox | sent | starred | all. */
export const listThreads = ({ folder = "inbox", q = "", pageToken = "" } = {}) =>
  api.get(`${BASE}/threads/`, {
    params: { folder, ...(q ? { q } : {}), ...(pageToken ? { page_token: pageToken } : {}) },
  }).then((r) => r.data);

/** One whole conversation. Opening it marks it read in Gmail. */
export const getThread = (threadId) =>
  api.get(`${BASE}/threads/${encodeURIComponent(threadId)}/`).then((r) => r.data);

/** One attachment of a message, as a Blob. */
export const downloadAttachment = (messageId, partId) =>
  api.get(
    `${BASE}/messages/${encodeURIComponent(messageId)}/attachments/${encodeURIComponent(partId)}/`,
    { responseType: "blob" },
  ).then((r) => r.data);
